import React from 'react';

function InvoicesSkeleton({ count = 5 }) {
    return (
        <div className="invoice-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div
                    className="invoice-skeleton__item ecx-page-list-item d-flex align-items-center gap-3 p-3"
                    key={`invoice-skeleton-${index}`}
                >
                    <div className="invoice-skeleton__icon flex-shrink-0" />
                    <div className="invoice-skeleton__content flex-grow-1 min-width-0">
                        <div className="invoice-skeleton__line invoice-skeleton__line--medium mb-2" />
                        <div className="invoice-skeleton__line invoice-skeleton__line--short" />
                    </div>
                    <div className="invoice-skeleton__button flex-shrink-0" />
                </div>
            ))}
        </div>
    );
}

export default InvoicesSkeleton;
